'use strict';

const FuseJS = require('fuse.js');
const Promise = require('promise-polyfill').default;
const calus = require('calus');
const { DateTime } = require('luxon');

const dates = require('util/dates');

const minBy = require('lodash/minBy');
const maxBy = require('lodash/maxBy');
const isEqual = require('lodash/isEqual');
const isString = require('lodash/isString');
const omit = require('lodash/omit');
const forEach = require('lodash/forEach');

function controller($scope, $timeout, $attrs, $location, $httpParamSerializer, plannerService) {
    const vm = this;

    let allResults = [];
    let performanceResults = [];
    let calendar = null;
    let previousView = false;
    let fuse = null;

    vm.loading = true;
    vm.updating = true;

    vm.totalCount = 0;
    vm.errorLoading = false;
    vm.totalPerformancesCount = 0;
    vm.results = [];
    vm.groupedFacets = [];
    vm.keyword = '';
    vm.selectedDate = null;

    vm.init = function () {
        const promises = [
            plannerService.getEvents(),
            plannerService.getPerformances(),
        ];

        Promise.all(promises).then(responses => {
            const [ events, performances ] = responses;

            // Keep track of all the results (that should appear in the listing)
            allResults = events.filter(event => event.show_in_listing);

            // No events = error
            vm.errorLoading = allResults.length === 0;

            // Setup fuse.js for filtering
            fuse = new FuseJS(allResults, plannerService.fuseOptions);

            // The same for performances
            performanceResults = performances;

            // Setup calendar
            setupCalendar();

            // With the results, also generate filters
            vm.groupedFacets = plannerService.generateFacets(performances);

            // Pre-tick facets set in query string
            vm.keyword = plannerService.applyQueryString(vm.groupedFacets).keyword;

            // Get initial display going, but don't update the location
            filterResults(false);

            // Resizing changes calendar...
            window.addEventListener('resize', processResize);

            // Get a watcher going on filters
            $scope.$watch(() => [vm.keyword, vm.groupedFacets], processChanges, true);

            // Get a watcher going on keyword input
            $scope.$watch(() => vm.selectedDate, processKeywordAndDateChange, true);

            // Get a watcher going on location search
            $scope.$watch(() => location.search, processLocationChange);
        }, e => {
            console.log(e);

            $timeout(() => {
                vm.errorLoading = true;
            });
        }).catch( e => {
            console.log(e);

            $timeout(() => {
                vm.errorLoading = true;
            });
        }).finally(function () {
            $timeout(() => {
                vm.loading = false;
            });
        });
    }

    function isDesktopView() {
        return window.matchMedia('(min-width: 50em)').matches === true;
    }

    function scrollToElement(selector) {
        $timeout(() => {
            const element = document.querySelector(selector);

            if (!element) {
                return;
            }

            window.scrollTo(0, element.offsetTop - (isDesktopView() ? 80 : 154 + 60 + 38));
        });
    }

    function setupCalendar() {
        const config = {
            el: document.querySelector('.calus'),
            displayInColumn: !isDesktopView(),
            timezone: 'Europe/London',
            limitCalendar: true,
            availableDates: performanceResults.map(performance => {
                return DateTime.fromISO(
                    performance.start_date_moment.toISOString()
                );
            }),
            onSelect: date => {
                if (!isDesktopView()) {
                    document.querySelector('[data-toggle="global-dates"]').click();
                }

                scrollToElement( '.performance-' + date.time.toISODate() );
            },
        }

        // Gab the minimum and maximum ranges
        if (performanceResults.length) {
            config.start = DateTime.fromISO(
                minBy(performanceResults, 'start_date').start_date_moment.toISOString()
            );

            config.end = DateTime.fromISO(
                maxBy(performanceResults, 'end_date').end_date_moment.toISOString()
            );
        }

        calendar = new calus(config);
    }

    function processResize() {
        const newView =  isDesktopView();

        if (previousView === newView) {
            return;
        }

        calendar.displayInColumn = !newView;

        previousView = newView;
    }

    function processChanges(newValue, oldValue) {
        // Lets not do anything whilst we're loading, updating, or if
        // nothing has changed, otherwise filter function will be called
        // multiple times.
        if (vm.loading === true || vm.updating === true || isEqual(newValue, oldValue) === true) {
            return false;
        }

        filterResults(true);
    }

    function processLocationChange(newValue, oldValue) {
        // Lets not do anything whilst we're loading, updating, or if
        // nothing has changed, otherwise filter function will be called
        // multiple times.
        if (vm.loading === true || vm.updating === true || isEqual(newValue, oldValue) === true) {
            return false;
        }

        // We only need to update the facets because items will update by
        // themselves because we're watching the facets for changes already
        vm.keyword = plannerService.applyQueryString(vm.groupedFacets).keyword;
    }

    function processKeywordAndDateChange(newValue, oldValue) {
        if (isEqual(newValue, oldValue) === true) {
            return false;
        }

        // Grab the queries from the URL
        let query = $location.search();

        // Determine if we actually have any params
        if (!query || !Object.keys(query).length) {
            query = {};
        }

        // Get rid of keyword and date
        delete query.keyword;
        delete query.date;

        // Do we have a keyword?
        if (isString(vm.keyword) && vm.keyword.length) {
            query.keyword = vm.keyword;
        }

        // Do we have a keyword?
        if (vm.selectedDate) {
            query.date = vm.selectedDate.format('YYYY-MM-DD');
        }
    }

    function filterResults(updateLocation) {
        // Start updating
        vm.updating = true;

        // Start with full result list
        let filteredResults = allResults;

        // Apply keyword filtering if possible?
        if (isString(vm.keyword) && vm.keyword.length) {
            filteredResults = fuse.search(vm.keyword);
        }

        // Get filtered count before we group
        vm.totalCount = filteredResults.length;

        // Performances count
        vm.totalPerformancesCount = filteredResults.length;

        // Expose!
        vm.filteredResults = plannerService.filterAndUpdate(filteredResults, vm.groupedFacets, updateLocation);

        // We need to also call keyword update because its now a separate call
        plannerService.updateQueryStringKeyword(vm.keyword);

        // Done updating
        $timeout(() => {
            vm.updating = false;
        });
    }

    return vm;
}

module.exports = [
    '$scope', '$timeout', '$attrs', '$location', '$httpParamSerializer', 'plannerService', controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/EventList.js